import { PATH_AUTH } from "config";

const AUTH_EXACT_PATHS = new Set<string>([
  PATH_AUTH.login,
  PATH_AUTH.ssoLogin,
  PATH_AUTH.ssoCallback,
  PATH_AUTH.oauthCallback,
  PATH_AUTH.register,
  PATH_AUTH.signup,
  PATH_AUTH.resendEmail,
  PATH_AUTH.forgotPassword,
  PATH_AUTH.cancelDeletion,
]);

const AUTH_PREFIX_PATHS = [
  PATH_AUTH.resetPassword,
  PATH_AUTH.emailVerification,
  PATH_AUTH.verifyAccount,
] as const;

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function isAuthRoute(pathname: string): boolean {
  const normalized = normalizePathname(pathname);
  if (AUTH_EXACT_PATHS.has(normalized)) {
    return true;
  }
  return AUTH_PREFIX_PATHS.some(
    (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`)
  );
}

export function shouldPassthroughAuthDuringMaintenance(options: {
  pathname: string;
  isMaintenance: boolean;
  isOnline: boolean;
  isBackendAvailable: boolean;
}): boolean {
  return (
    options.isMaintenance &&
    options.isOnline &&
    !options.isBackendAvailable &&
    isAuthRoute(options.pathname)
  );
}
